import { Link, useLocation } from "react-router-dom";
import { Home, Sparkles, HeartHandshake } from "lucide-react";

/* Fixed bottom navigation on mobile, on every page:
   Home | Free Lifespan Markers | Back Us */
const MobileBottomNav = () => {
  const { pathname } = useLocation();
  const items = [
    { to: "/", label: "Home", icon: Home, testId: "bottomnav-home", active: pathname === "/" },
    { to: "/assessment?src=bottomnav", label: "Free Lifespan Markers", icon: Sparkles, testId: "bottomnav-assessment", active: pathname.startsWith("/assessment") },
    { to: "/subscribe", label: "Subscribe", icon: HeartHandshake, testId: "bottomnav-back-us", active: pathname.startsWith("/subscribe") },
  ];

  return (
    <nav
      aria-label="Quick navigation"
      data-testid="mobile-bottom-nav"
      className="fixed inset-x-0 bottom-0 z-[60] border-t border-white/10 bg-void/95 backdrop-blur-xl lg:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="grid grid-cols-3">
        {items.map((it) => (
          <Link
            key={it.to}
            to={it.to}
            data-testid={it.testId}
            className={`flex min-h-[60px] flex-col items-center justify-center gap-1 px-1 text-[9px] font-semibold tracking-wide transition-colors duration-200 ${
              it.active ? "text-green-300" : "text-fog hover:text-white"
            }`}
          >
            <it.icon className="h-5 w-5" />
            <span className="max-w-full text-center leading-tight">{it.label}</span>
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
